import { Flex } from '@aloft/toolkit-sui';

import { selectDepreciationSettings } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { ContentBlock } from '../ColumnComponents/ContentBlock.tsx';
import { ExternalDepreciation } from './DepreciationAdditionalSettings/ExternalDepreciation.tsx';
import { FunctionalDepreciation } from './DepreciationAdditionalSettings/FunctionalDepreciation.tsx';

export function Depreciation({ id }: { id: string }) {
  const { enableFunctionalDepreciation, enableExternalDepreciation } = useAppSelector(
    selectDepreciationSettings,
  );

  return (
    (enableFunctionalDepreciation || enableExternalDepreciation) && (
      <ContentBlock>
        <Flex justifyContent="space-between" gap="0.5rem" flexDirection="column">
          {enableFunctionalDepreciation && <FunctionalDepreciation id={id} />}
          {enableExternalDepreciation && <ExternalDepreciation id={id} />}
        </Flex>
      </ContentBlock>
    )
  );
}
